(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const announcementContainers = document.querySelectorAll('.announcement-slider');
  
  announcementContainers.forEach(function(container) {
    const slides = container.querySelectorAll('.announcement-slide');
    const wrapper = container.querySelector('.announcement-slides-wrapper');
    const autoRotate = container.dataset.autoRotate === 'true';
    const changeSlidesSpeed = parseInt(container.dataset.changeSlidesSpeed) || 5000;
    
    if (slides.length <= 1) return;
    
    let currentIndex = 0;
    let intervalId = null;
    
    function goToSlide(index) {
      currentIndex = index;
      wrapper.style.transform = 'translateY(-' + (currentIndex * 100) + '%)';
    }
    
    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      goToSlide(nextIndex);
    }
    
    function startAutoRotate() {
      if (autoRotate && !intervalId) {
        intervalId = setInterval(nextSlide, changeSlidesSpeed);
      }
    }
    
    function stopAutoRotate() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }
    
    container.addEventListener('mouseenter', stopAutoRotate);
    container.addEventListener('mouseleave', startAutoRotate);
    
    startAutoRotate();
  });
});
  } catch(e) { console.error(e); }
})();

})();
